
import { FC, createContext, useContext, useState, ReactNode, useEffect, useCallback } from 'react';
import { TDropItem } from 'src/types';
import { getDomainV1 } from 'src/apis/getDomainV1';
import { useAuth } from './AuthProvider';

export interface CountryContextType {
  countries: TDropItem[] | undefined;
  fetchCountries: () => Promise<void>;
}

export const CountryContext = createContext<CountryContextType>(undefined!);

interface CountryProviderProps {
  children: Nullable<ReactNode>;
}

export const CountryProvider: FC<CountryProviderProps> = ({ children }) => {
  const { isLoggedIn } = useAuth();
  const [countries, setCountries] = useState<TDropItem[] | undefined>();

  const fetchCountries = useCallback(async () => {
    try {
      !countries && setCountries(await getDomainV1('country'));
    } catch (e) {
      console.log('An error occurred retrieving the countries: ', e);
    }
  }, [countries]);

  useEffect(() => {
    if (isLoggedIn) {
      fetchCountries();
    }
  } , [isLoggedIn, fetchCountries]);

  return (
    <CountryContext.Provider
      value={{
        countries,
        fetchCountries
      }}>
      {children}
    </CountryContext.Provider>
  );
};

export const useCountries = () => {
  return useContext(CountryContext);
};
